import { createFileRoute } from "@tanstack/react-router";
import AdminCreatorsPage from "@/admin/pages/creators";

export const Route = createFileRoute("/admin/creators")({
  component: AdminCreatorsPage,
});
